/* eslint-disable no-shadow */
import {createContext, useState, Fragment, ReactNode, useCallback, useMemo} from "react";

type animateType = "basic" | "slideIn";
export interface Open {
	animate: animateType;
}

export const OverlayContext = createContext<{
	mount(id: string, element: ReactNode): void;
	unmount(id: string): void;
} | null>(null);

const OverlayProvider = ({children}: {children: ReactNode}) => {
	const [overlayById, setOverlayById] = useState<Map<string, ReactNode>>(new Map());

	const mount = useCallback((id: string, element: ReactNode) => {
		setOverlayById(overlayById => {
			const cloned = new Map(overlayById);
			cloned.set(id, element);
			return cloned;
		});
	}, []);

	const unmount = useCallback((id: string) => {
		setOverlayById(overlayById => {
			const cloned = new Map(overlayById);
			cloned.delete(id);
			return cloned;
		});
	}, []);

	const context = useMemo(() => ({mount, unmount}), [mount, unmount]);

	return (
		<OverlayContext.Provider value={context}>
			{children}
			{[...overlayById.entries()].map(([id, element]) => (
				<Fragment key={id}>{element}</Fragment>
			))}
		</OverlayContext.Provider>
	);
};

export default OverlayProvider;
